// @flow

import reportInviteLand from 'app/packages/invite-utils/reportInviteLand';
import { parseQuery } from 'app/packages/url';

type NoInviteCb = (query: Object) => void;
const logInviteAttribution = (noInviteCb: NoInviteCb = (query: Object) => {}): void => {
  if (__SERVER__) {
    return;
  }

  const query = parseQuery(window.location.search);
  const invite_code = query.invite_code;

  if (!invite_code) {
    // NOTE: here we check for nic
    noInviteCb(query);
    return;
  }

  reportInviteLand(invite_code);
};

export default logInviteAttribution;
